import React, { useEffect, useState } from "react";
import "./ShopPage.css";
import HeaderBanner from "../../Components/HeaderBanner/HeaderBanner";
import ProductCard from "../../Components/ProductCard/ProductCard";
import ProductModal from "../../Components/ProductModal/ProductModal";
import { shopData } from "../../shopData";

export default function ShopPage() {
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="shop-page-wrapper">
      <HeaderBanner title="Our Shop" currentPath="Shop" />
      <div className="shop-container">
        <div className="shop-header">
          <h6 className="small-header">Apparel Collections</h6>
          <h2>Discover our exclusive range of high-quality apparel.</h2>
        </div>

        <div className="shop-grid">
          {shopData.map((item) => (
            <ProductCard key={item.id} item={item} onSelect={setSelectedItem} />
          ))}
        </div>
      </div>

      {selectedItem && (
        <ProductModal
          item={selectedItem}
          onClose={() => setSelectedItem(null)}
        />
      )}
    </div>
  );
}
